import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
    return (_openBlock(), _createElementBlock("span", null, [
        (_ctx.isFaIcon)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: _ctx.icon
            }, null, 8, ["icon"]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                innerHTML: _ctx.svg,
                class: "svg-icon"
            }, null, 8, _hoisted_1))
    ]));
}
